/* Cart progress bar (snippets/cart-progress.liquid).
   Keeps every bar on the page in step with the cart: any request that changes the
   cart (add, change, update, clear) triggers a fresh read of /cart.js, and any read
   of /cart.js by the theme (the cart drawer does one each time it redraws) is reused. */
(() => {
  'use strict';
  if (window.EssaintCartProgress) return;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = cents => {
    const v = Math.max(0, cents) / 100;
    const whole = Math.round(v * 100) % 100 === 0;
    return '$' + v.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 });
  };
  const isGift = item => !!(item.properties && item.properties._essaint_gift);
  // Same rules as Shopify's Buy X get Y discount: the free T-shirt never counts toward the amount,
  // so while a T-shirt is in the bag but not yet free, one T-shirt is left out.
  const giftInBag = (cart, title) => !!title && (cart.items || []).some(i => (i.line_level_discount_allocations || [])
    .some(a => a.amount > 0 && a.discount_application && a.discount_application.title === title));
  const eligible = (cart, el) => {
    const items = cart.items || [];
    let s = (cart.total_price || 0) - items.filter(isGift).reduce((n, i) => n + (i.final_line_price || 0), 0);
    if (el.dataset.giftReady === 'true' && !giftInBag(cart, el.dataset.giftTitle)) {
      const tees = items.filter(i => String(i.product_id) === el.dataset.giftProduct && i.quantity > 0);
      if (tees.length) s -= Math.min(...tees.map(i => i.final_line_price / i.quantity));
    }
    return Math.max(0, Math.round(s));
  };

  const flags = el => {
    const t1 = +el.dataset.t1, t2 = +el.dataset.t2, ready = el.dataset.giftReady === 'true' && t2 > t1;
    return { t1, t2, ready, show: ready || (el.dataset.giftShow === 'true' && t2 > t1) };
  };

  function message(el, s, inBag) {
    const { t1, t2, ready, show } = flags(el);
    const url = el.dataset.giftUrl || '#';
    const sep = '<span class="cp-sep">·</span>';
    if (ready && (inBag || s >= t2)) return { state: 'gift', html: `<span class="cp-ok">Free delivery and a free T-Shirt unlocked</span>` + (inBag ? '<span class="cp-note">Your free T-shirt is in your bag</span>' : `<a class="cp-claim" href="${url}">Choose your free T-shirt</a>`) };
    if (show && s >= t2) return { state: 'soon', html: `<span class="cp-ok">Free delivery unlocked</span>${sep}<span class="cp-part">Free T-Shirt offer coming soon</span>` };
    if (s >= t1) return { state: 'delivery', html: `<span class="cp-ok">Free delivery unlocked</span>` + (show ? `${sep}<span class="cp-part"><strong>${money(t2 - s)}</strong> from a free T-Shirt</span>` : '') };
    return { state: 'start', html: `<span class="cp-part"><strong>${money(t1 - s)}</strong> away from free delivery</span>` };
  }

  function paint(cart) {
    document.querySelectorAll('[data-cart-progress]').forEach(el => {
      const { t1, t2, ready, show } = flags(el);
      const goal = show ? t2 : t1;
      const inBag = ready && giftInBag(cart, el.dataset.giftTitle);
      const s = eligible(cart, el);
      const { state, html } = message(el, s, inBag);
      if (el.dataset.state !== state || el.dataset.cents !== String(s) || el.dataset.inBag !== String(inBag)) {
        el.querySelector('[data-cp-message]').innerHTML = html;
      }
      el.dataset.state = state;
      el.dataset.cents = String(s);
      el.dataset.inBag = String(inBag);
      el.querySelector('[data-cp-fill]').style.width = (state === 'gift' ? 100 : Math.min(100, s / goal * 100)) + '%';
      el.querySelectorAll('[data-cp-node]').forEach(n => n.classList.toggle('is-done', state === 'gift' || (n.dataset.cpNode === '1' && s >= t1)));
      if (el.classList.contains('cart-progress--drawer')) el.hidden = !cart.item_count;
    });
  }

  const nativeFetch = window.fetch.bind(window);
  let timer;
  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(r => r.ok ? r.json() : null).then(c => c && paint(c)).catch(() => {});
    }, 120);
  };

  window.fetch = function (input, init) {
    const p = nativeFetch(input, init);
    try {
      const url = new URL(typeof input === 'string' ? input : input.url, location.href);
      const path = url.pathname.replace(/\/+$/, '');
      const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (/\/cart\.js$/.test(path) && method === 'GET') {
        p.then(r => r.ok && r.clone().json().then(paint)).catch(() => {});
      } else if (/\/cart\/(add|change|update|clear)(\.js)?$/.test(path)) {
        // Re-read even after an error: Shopify can still change the cart (e.g. adds what is in stock).
        p.then(refresh, refresh);
      }
    } catch (e) {}
    return p;
  };

  // Coming back to a page from the browser's history shows an old copy: re-read the cart.
  window.addEventListener('pageshow', e => { if (e.persisted) refresh(); });
  window.EssaintCartProgress = { refresh, paint, money };
})();
